'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeisParticipant = undefined;

var _getFeisParticipant2 = require('./getFeisParticipant');

var _getFeisParticipant3 = _interopRequireDefault(_getFeisParticipant2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.getFeisParticipant = _getFeisParticipant3.default;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/person/index.js
// module id = 657
// module chunks = 0